import * as J from "../../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
import { getAspectCorrectedCoordinates as Z } from "../../utilities/uv.js";
import { grain as $ } from "../../helpers/grain.js";
import { distort as oo } from "../../helpers/distort.js";
import { glow as to } from "../../helpers/glow.js";
import { edgeMask as so } from "../../helpers/edgeMask.js";
const ao = {
  name: "Chromatic2",
  collection: "chromatic",
  tags: ["wave", "gradient"],
  props: {
    speed: {
      type: Number,
      default: 1,
      description: "The speed of the wave effect."
    }
  },
  fragmentNode: (m) => {
    const {
      vec3: d,
      vec4: E,
      time: O,
      mix: n,
      sin: T,
      float: o,
      pow: c,
      uv: f,
      color: t
    } = J, l = t("#33b351"), N = t("#36df39"), u = t("#3274aa"), r = t("#2b84ff"), C = t("#29d1d1"), S = t("#0739ff"), p = 0.5, I = 0.5, R = 0, D = 0.1, G = 0.1, A = 0.5, L = 21, g = 0.7, b = 0.03, Y = 0.5, F = 0.5, v = 0.1, w = 0.6, x = 1, U = 0.05, B = 0.02, s = f(), { correctedUV: V } = Z(), _ = oo(s, G, A, L), W = c(l, o(2.2)), h = c(N, o(2.2)), y = c(u, o(2.2)), k = c(r, o(2.2)), H = n(
      W,
      h,
      s.y
    ), P = n(
      k,
      y,
      s.x
    ), K = n(
      H,
      P,
      s.x
    ), a = _.x.sub(0.3), i = _.y.sub(0.5), M = i.mul(a).add(i.mul(a)).negate(), e = o(1).add(
      o(g).mul(
        T(
          M.add(O.mul(m.speed.uniform).mul(0.025)).div(b)
        )
      )
    ), Q = so({
      inset: p,
      softness: I,
      offsetX: R,
      offsetY: D
    }), X = d(e, e, e).mul(Q).mul(Y), z = n(
      S.mul(B),
      C.mul(U),
      s.y.mul(s.x)
    ), j = $(F)(V), q = E(
      z.add(K.mul(X)).sub(j),
      1
    );
    return to(q, r, v, w, x);
  }
};
export {
  ao as componentDefinition,
  ao as default
};
